// src/contexts/GameContext.jsx
import React, { createContext, useContext, useState } from 'react';
import { streaming } from '../services/api';

export const GameContext = createContext();

export const GameProvider = ({ children }) => {
  const [gameState, setGameState] = useState(null);
  const [session, setSession] = useState(null);
  const [error, setError] = useState(null);

  const startGame = async (gameId, config) => {
    try {
      const response = await streaming.startSession(gameId);
      setSession(response.data);
      setGameState(config.initialState);
      setError(null);
      return response.data;
    } catch (err) {
      setError('Failed to start game session');
      throw err;
    }
  };

  const updateGameState = (newState) => {
    setGameState(prevState => ({
      ...prevState,
      ...newState
    }));
  };

  const endGame = async () => {
    if (session?.id) {
      try {
        await streaming.endSession(session.id);
        setSession(null);
        setGameState(null);
      } catch (err) {
        setError('Failed to end game session');
        throw err;
      }
    }
  };

  return (
    <GameContext.Provider value={{
      gameState,
      session,
      error,
      startGame,
      updateGameState,
      endGame
    }}>
      {children}
    </GameContext.Provider>
  );
};

export const useGame = () => {
  const context = useContext(GameContext);
  if (!context) {
    throw new Error('useGame must be used within a GameProvider');
  }
  return context;
};


